import { formatDate as formatSwissDate } from '@agentselly/ui';

/**
 * Datum als TT.MM.JJJJ. Dünne Hülle um den geteilten Formatter aus
 * `@agentselly/ui`, damit es im Monorepo nur eine Intl-Implementierung für den
 * Schweizer Standard gibt (AGE-162).
 *
 * Unterschied zum geteilten Formatter: fehlende oder ungültige Daten ergeben
 * hier den Leerstring statt `—`, weil die Aufrufer darauf bedingt rendern.
 */
export function formatDate(dateString: any): string {
  return formatSwissDate(dateString, { fallback: '' });
}
